// Avis acheteur -> prestataire (serialise par le backend).
export interface AvisData {
  id: number;
  type_commande: 'BC' | 'MS';
  commande_id: number;
  // Id de l'operation cote acheteur (lien vers /operation-bc|ms/:id) ; null pour les avis anciens.
  operation_id: number | null;
  entite_id: number;
  organisme_id: number;
  note: number;
  commentaire: string | null;
  numero_commande: string | null;
  date_commande: string | null;
  departement_code: string | null;
  departement_nom: string | null;
  // Snapshot du lot technique de la commande (code + nom), pour l'entete de l'avis.
  lot_technique_code: string | null;
  lot_technique_nom: string | null;
  entite_nom: string | null;
  organisme_nom: string | null;
  // Logos reels (acheteur = organisme, prestataire = entite) ; null si aucun.
  organisme_logo_url: string | null;
  entite_logo_url: string | null;
  updated_at: string | null;
}

export const COMMENTAIRE_MAX = 1000;

export const fmtDateFr = (iso?: string | null): string => {
  if (!iso) return '';
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '' : d.toLocaleDateString('fr-FR');
};

// "23/08/2025, (73) Savoie" a partir du snapshot de la commande.
export const commandeLocationLabel = (a: AvisData): string => {
  const place = [a.departement_code ? `(${a.departement_code})` : '', a.departement_nom ?? ''].filter(Boolean).join(' ');
  return [fmtDateFr(a.date_commande), place].filter(Boolean).join(', ');
};

// Trois lignes d'entete de l'avis : lot technique, lot geographique, numero de panier.
// "{code} – {nom}" (tiret cadratin) ; chaque morceau tombe sur ce qu'il a, "—" si rien.
const codeAndName = (code: string | null, name: string | null): string =>
  [code, name].filter(Boolean).join(' – ') || '—';

export const lotTechniqueLabel = (a: AvisData): string => codeAndName(a.lot_technique_code, a.lot_technique_nom);

export const lotGeoLabel = (a: AvisData): string => codeAndName(a.departement_code, a.departement_nom);

export const panierLabel = (a: AvisData): string => (a.operation_id ? `N°${a.operation_id}` : '—');
